export default "__VITE_ASSET__Hh7xI9T6__"